import React, { useState, useEffect, useRef } from "react";
import { SplitScreen } from "./components/SplitScreen";
import Page from "./Page";
import SideBar from "./Page/SideBar";
import Toaster from "./stories/Toasts/Toaster";
import { useAuth } from "./components/AuthContext/AuthContext";
import { Container, Spinner, Navbar } from "react-bootstrap";
import Flag from "../src/components/Flag";
import NotFound from "./components/NotFound";
import ButtonModal from "./stories/Modal/ButtonModal";
import EnableMFA from "./views/Account/EnableMFA.jsx";
import VerifyOTP from "./views/Account/VerifyOTP.jsx";
import useApis from "./services/useAPI";
import { useNavigate, useLocation } from "react-router-dom";
import MobileMenu from "./Page/MobileMenu";
import { toSentenceCase } from './utils/utils';
import { initGA } from "./components/Analytics.js";
import 'react-time-picker/dist/TimePicker.css';
import 'react-clock/dist/Clock.css';
import "react-datepicker/dist/react-datepicker.css";
import TemporarilyDown from "./components/TemporarilyDown";
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  const auth = useAuth();
  const navigate = useNavigate();
  const mfa = JSON.parse(localStorage.getItem("mfa_enabled")) || null;
  const is_logged_in_first_time = JSON.parse(localStorage.getItem("is_logged_in_first_time")) || null;
  const isLoggedIn =
    (JSON.parse(localStorage.getItem("isLoggedIn")) || false) &&
    localStorage.getItem("mfa_pending") !== "true";
  const [show, setShow] = useState(
    is_logged_in_first_time ? false : !mfa
  );
  const [isPhlebotomyRoute, setIsPhlebotomyRoute] = useState(null);
  const location = useLocation();
  const regexForIsCard = /^\/assessment\/\d+\/5$/;
  const { resultGet, isLoading, showTemporarilyDown } = useApis();
  const [isAccountPage, setIsAccountPage] = useState(false);
  const hostname = globalThis.location.hostname;
  const [showEnableMFA, setShowEnableMFA] = useState(false);
  const [isOtpFields, setIsOtpFields] = useState(false);
  const [showVerifyOTP, setShowVerifyOTP] = useState(false);
  const addNumberformikRef = useRef(null);
  useEffect(() => {
    if (hostname === 'dashboard.myhealthchecked.com') {
      initGA();
    }
  }, []);
  useEffect(() => {
    return () => {
      if (!window.location.pathname.includes("/assessment" && "/5")) {
        localStorage.removeItem('assessment_completed');
        localStorage.removeItem('test_kit_id_completed');
      }
    };
  }, []);

  useEffect(() => {
    if (globalThis.location.pathname) {
      globalThis.gtag?.("event", "page_view", {
        page_location: globalThis.location.href,
        page_path: globalThis.location.pathname,
      });
    }
    if (location.pathname === "/account") {
      setIsAccountPage(true);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (globalThis.location.pathname.includes("/boots")) {
      setIsPhlebotomyRoute(true);
    }
  }, [resultGet]);

  useEffect(() => {
    const mfa = JSON.parse(localStorage.getItem("mfa_enabled"));
    const isLoggedIn = JSON.parse(localStorage.getItem("isLoggedIn"));
    if (showEnableMFA || showVerifyOTP) {
      setShow(false);
    } else {
      setShow(
        isLoggedIn &&
        !mfa &&
        !is_logged_in_first_time &&
        location.pathname !== "/enable-mfa"
      );
    }

  }, [location.pathname]);

  useEffect(() => {
    const handlePopState = (e) => {
      const popup = e.state?.popup;

      if (showVerifyOTP) {
        setShowVerifyOTP(false);
        setShowEnableMFA(true);
      } else if (showEnableMFA) {
        setShowEnableMFA(false);
        setShow(true);
      }
    };

    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, [showVerifyOTP, showEnableMFA]);


  const handleHide = () => {
    localStorage.setItem("defered_mfa", true);
    setShow(false);
  };

  const handleMFA = () => {
    setShow(false);
    setShowEnableMFA(true);
    window.history.pushState({ popup: "enableMFA" }, "");
  };

  const handleMFAComplete = () => {
    setShowVerifyOTP(false);
  };
  const handleAddNumber = async () => {
    await addNumberformikRef.current.submitForm();
  };
  if (!auth?.isHcpLive && isPhlebotomyRoute) {
    return (
      <SplitScreen isSidebar={true} rightWeight={4}>
        <SideBar isPhlebotomyRoute={isPhlebotomyRoute} />
        <Container fluid className="mt-4 mt-md-3">
          <NotFound />
        </Container>
      </SplitScreen>
    );
  }
  if (showTemporarilyDown) {
    return <TemporarilyDown />;
  }

  return (
    <main>
      <Flag />
      {(isLoggedIn && location.pathname !== "/confirm-otp") ? (
        <SplitScreen isSidebar={true} rightWeight={4}>
          <SideBar isPhlebotomyRoute={isPhlebotomyRoute} />
          <Container fluid className={`${regexForIsCard.test(location.pathname) ? '' : "mt-3 mt-md-3"}`}>
            {isLoading ? (
              <div className="text-center">
                <Spinner animation="border" className="custom-spinner" />
              </div>
            ) : (
              <div className={`${regexForIsCard.test(location.pathname) ? '' : "mobile-page-container container-fluid mt-4 "}${isAccountPage ? "on-account-page" : ""}`}>
                <Page />
              </div>
            )}
            {show && (
              <ButtonModal
                heading={"Enable Multi-Factor Authentication"}
                show={show}
                titleClass={"enable-mfa-title"}
                showCloseButton={false}
                keyboard={false}
                centered={true}
                onClick ={handleAddNumber}
                backdrop="static"
                modalClass="enable-mfa-form-modal"
                addNumberformikRef={addNumberformikRef}
                btn_label_2={isOtpFields ?"Verify":"Confirm"}
                btn2_class="btn-green"
              >
                <EnableMFA
                  onProceedToOTP={() => {
                    window.history.pushState({ popup: "verifyOTP" }, "");
                  }}
                  onVerifySuccess={() => {
                    setShowEnableMFA(false);
                   window.history.pushState({ popup: "verifyOTP" }, "");
                  }}
                  addNumberformikRef={addNumberformikRef}
                 setIsOtpFields={setIsOtpFields}
                />
              </ButtonModal>
            )}
            {showVerifyOTP && (
              <ButtonModal
                show={showVerifyOTP}
                showCloseButton={false}
                keyboard={false}
                backdrop="static"
                modalClass="enable-mfa-form-modal"
              >
                <VerifyOTP onSuccess={handleMFAComplete} />
              </ButtonModal>
            )}
            <MobileMenu />
          </Container>
          <Toaster newToast={auth?.toast} />
        </SplitScreen>)
        : (
          <Page />
        )
      }
    </main>
  );
}

export default App;
